import { ArrowUpDown, ChevronDown, ChevronUp } from 'lucide-react'
import { TableHead } from '@/components/ui/table'
import { cn } from '@/lib/utils'
import {
  getDefaultDirection,
  type ClubReportSort,
  type ClubReportSortKey,
} from './club-participation-sort'

/** A club table column that sorts the table when its header is chosen. */
export function ClubSortHeader({
  label,
  sortKey,
  sort,
  onSort,
  align = 'left',
}: {
  label: string
  sortKey: ClubReportSortKey
  sort: ClubReportSort
  onSort: (key: ClubReportSortKey) => void
  align?: 'left' | 'right'
}) {
  const active = sort.key === sortKey
  const direction = (active ? sort.direction : getDefaultDirection(sortKey)) === 'asc'
  const directionText = direction ? 'ascending' : 'descending'
  return (
    <TableHead
      aria-sort={active ? directionText : 'none'}
      className={align === 'right' ? 'text-right' : undefined}
    >
      <button
        type="button"
        className={cn(
          'flex w-full items-center gap-1 font-medium',
          align === 'right' ? 'justify-end text-right' : 'justify-start text-left'
        )}
        aria-label={
          active
            ? `Sort by ${label} (${directionText})`
            : `Sort by ${label} (default ${directionText})`
        }
        onClick={() => onSort(sortKey)}
      >
        <span>{label}</span>
        {!active ? (
          <ArrowUpDown aria-hidden="true" className="h-4 w-4 text-muted-foreground" />
        ) : direction ? (
          <ChevronUp aria-hidden="true" className="h-4 w-4 text-muted-foreground" />
        ) : (
          <ChevronDown aria-hidden="true" className="h-4 w-4 text-muted-foreground" />
        )}
      </button>
    </TableHead>
  )
}
